// Model.js
// -----------------------
// @module Case
define("NVT.anuualupdateform.anuualupdateform.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/anuualupdateform/SuiteScript2/anuualupdateform.Service.ss"
            ),
            true
        )
});
});
